import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../hooks/useTitle';
import { axiosInstance } from '../../utils/axios';
import { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
  notification,
} from 'antd';
import { useDispatch } from 'react-redux';
import { verifyCode } from '../../redux/slices/candidateAuth.slice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { parseContent } from '../../utils/parseContent';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import '../../styles/screening.css';

const { Title, Text } = Typography;

function BeginScreening() {
  const { t } = useTranslation(['screening/start-screen']);
  useTitle(t('Title'));
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [codeRequested, setCodeRequested] = useState<boolean>(false);
  const [loadingRequestCode, setLoadingRequestCode] = useState<boolean>(false);
  const [loadingVerifyCode, setLoadingVerifyCode] = useState<boolean>(false);

  useEffect(() => {
    if (!token) return notification.error({ message: t('EM-InvalidToken') });
    axiosInstance
      .get(`/screening/candidate/${token}`)
      .then((response) => {
        setPhoneNumber(response.data.phoneNumber);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          navigate('/error/tokenHasExpired');
        }
      });
  }, [token, navigate, t]);

  const requestSmsCode = () => {
    if (!token) return notification.error({ message: t('EM-InvalidToken') });
    setLoadingRequestCode(true);
    axiosInstance
      .post(`/candidate/auth/request-code/`, { token: token })
      .then(() => {
        setCodeRequested(true);
        setLoadingRequestCode(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const onFinish = (values: { code: string }) => {
    setLoadingVerifyCode(true);
    if (!token) return notification.error({ message: t('EM-InvalidToken') });

    dispatch(verifyCode({ code: values.code, token: token }) as any)
      .unwrap()
      .then(() => {
        navigate('/screening');
      })
      .catch((reason: any) => {
        notification.error({
          message: `${reason.message}`,
          placement: 'bottomRight',
          type: 'error',
        });
        setLoadingVerifyCode(false);
      });
  };

  return (
    <Row justify="center" align="middle" style={{ margin: '50px auto' }}>
      <LanguageSwitcher />
      <Col xs={24} md={12} lg={8}>
        <Card
          title={
            <div style={{ marginBlock: 15 }}>
              <Text strong>{t('P-Title')}</Text>
              <Title level={3} style={{ marginBlock: 0, textWrap: 'wrap' }}>
                {t('P-LoginTitle')}
              </Title>{' '}
            </div>
          }
        >
          <div>
            <Text>
              {parse(
                parseContent(t('P-LoginDescription'), [
                  `<strong>${phoneNumber}</strong>`,
                ]),
              )}
            </Text>
          </div>
          <Button
            type="dashed"
            onClick={requestSmsCode}
            loading={loadingRequestCode}
            style={{ marginTop: 20 }}
          >
            {t('P-RequestCode')}
          </Button>
          {codeRequested && (
            <Form
              layout="vertical"
              style={{ marginTop: '20px' }}
              onFinish={onFinish}
            >
              <Form.Item
                label={t('L-VerificationCode')}
                name="code"
                style={{ marginTop: '20px' }}
              >
                <Input
                  placeholder={t('PH-VerificationCode') ?? ''}
                  maxLength={10}
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                loading={loadingVerifyCode}
              >
                {t('B-VerifyCode')}
              </Button>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default BeginScreening;
